import React from 'react'

function Shadow() {
	return (
		<svg width="97" height="14" viewBox="0 0 97 14" fill="none" xmlns="http://www.w3.org/2000/svg">
			<g style={{ mixBlendMode: 'color-burn' }} filter="url(#filter0_f_1835_68475)">
				<ellipse cx="48.498" cy="7.1604" rx="43.8652" ry="2.84448" fill="#D9D9D9" />
			</g>
			<defs>
				<filter id="filter0_f_1835_68475" x="0.632812" y="0.315918" width="95.7305" height="13.689" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
					<feFlood flood-opacity="0" result="BackgroundImageFix" />
					<feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
					<feGaussianBlur stdDeviation="2" result="effect1_foregroundBlur_1835_68475" />
				</filter>
			</defs>
		</svg>
	)
}

export default Shadow
